import cn from 'classnames';
import { Sidebar as PrimeReactSidebar } from 'primereact/sidebar';
import { useState } from 'react';

import Navigation from '@shared/components/Navigation/Navigation.tsx';
import UserProfile from '@shared/components/UserProfile/UserProfile.tsx';
import { useUserDetails } from '@shared/providers/UserDetailsProvider/useUserDetails.tsx';
import { determineAdmanagerBrandData } from '@shared/utils/determineAdmanagerBrandData.ts';

import styles from './Sidebar.module.scss';

function Sidebar() {
  const [isVisible, setIsVisible] = useState(false);
  const { countryCode } = useUserDetails();

  const { logoSrc, logoSignetSrc, altText } = determineAdmanagerBrandData(countryCode);

  return (
    <PrimeReactSidebar
      data-testid={'navigation-sidebar'}
      showCloseIcon={false}
      appendTo='self'
      visible
      onMouseOver={() => setIsVisible(true)}
      onMouseLeave={() => setIsVisible(false)}
      onHide={() => setIsVisible(false)}
      maskClassName={cn(styles.sidebarMaskWrapper, isVisible ? styles.sidebarUncollapse : styles.sidebarCollapse)}
      className={cn(styles.sidebarWrapper)}
    >
      <div className={styles.sidebarHeader}>
        <img
          src={logoSignetSrc}
          className={cn(styles.logoImg, { [styles.zeroOpacity]: isVisible })}
          alt={'AdManager'}
        />
        <img src={logoSrc} className={cn(styles.newLogoText, { [styles.fullOpacity]: isVisible })} alt={altText} />
      </div>
      <Navigation />
      <div className={styles.sidebarFooter}>
        <UserProfile isSidebarCollapsed={!isVisible} />
      </div>
    </PrimeReactSidebar>
  );
}

export default Sidebar;
